module.exports = __webpack_public_path__ + "img/tl.3c1ccf11.svg";